import { useContext, useEffect } from "react";
import Module1 from "../Modules/Module1";
import Module2 from "../Modules/Module2";
import Module3 from "../Modules/Module3";
import AppContext from "../Context/AppContext";

import Layout from "../Components/Layout";
import SkuBatchInquiry from "../Modules/Inquiry/SkuBatchInquiry";
import ItemSKUInventoryDetailsInquiry from "../Modules/Inquiry/ItemSKUInventoryDetailsInquiry";
import SkuBatchInventoryTrackInquiry from "../Modules/Inquiry/SkuBatchInventoryTrackInquiry";
import InvoiceRegisterInquiry from "../Modules/Inquiry/InvoiceRegisterInquiry";
import TestInquiry from "../Modules/Inquiry/TestInquiry";
import InBoundReceiptsInquiry from "../Modules/Inquiry/InBoundReceiptsInquiry";
import InBoundOrdersInquiry from "../Modules/Inquiry/InBoundOrdersInquiry";
import SkuInventoryTrackInquiry from "../Modules/Inquiry/SkuInventoryTrackInquiry";
import RollingInventoryDetailsInquiry from "../Modules/Inquiry/RollingInventoryDetailsInquiry";
import CPMReportInquiry from "../Modules/Inquiry/CPMReportInquiry";
// import DashBoard from "../Modules/Dashboard";
import DailyInventoryTrackHistoryInquiry from "../Modules/Inquiry/DailyInventoryTrackHistoryInquiry";
import SalesOrderMaintenance from "../Modules/SalesOrderMaintenance";
import InvoiceMaintenance from "../Modules/InvoiceMaintenance";
import AllCustomerOnlineAgingInquiry from "../Modules/Inquiry/AllCustomerOnlineAgingInquiry";
import CustomerBalanceInquiry from "../Modules/Inquiry/CustomerBalanceInquiry";

import SalesPersonOrder from "../Modules/Inquiry/SalesPersonOrder";
import DashBoard from "../Modules/PortalDashboard";
import ATSInquiry from "../Modules/Inquiry/ATSInquiry";

const Home = ({ logoutHandler }) => {
  const { activeTab, setActiveTab, isLoading } = useContext(AppContext);
  useEffect(() => {
    renderModule();
  }, [activeTab]);
  const renderModule = () => {
    switch (activeTab) {
      case "sku":
        return <SkuBatchInquiry id="module" />;
      case "skuInv":
        return <ItemSKUInventoryDetailsInquiry id="module" />;
      case "skuBatchTrack":
        return <SkuBatchInventoryTrackInquiry id="module" />;
      case "skuTrack":
        return <SkuInventoryTrackInquiry id="module" />;
      // case "invoice":
      //   return <InvoiceRegisterInquiry id="module" />;
      case "inboundOrder":
        return <InBoundOrdersInquiry id="module" />;
      case "inboundReceipt":
        return <InBoundReceiptsInquiry id="module" />;
      case "module1":
        return <Module1 id="module" />;
      case "module2":
        return <Module2 id="module" />;
      case "module3":
        return <Module3 id="module" />;
      case "test":
        return <TestInquiry id="module" />;
      case "rollingInventory":
        return <RollingInventoryDetailsInquiry id="module" />;
      case "cpm":
        return <CPMReportInquiry id="module" />;
      case "dailyInventoryTrack":
        return <DailyInventoryTrackHistoryInquiry id="module" />;
      case "dashBoard":
        return <DashBoard id="module" />;

         case "salesOrder":
        return <SalesOrderMaintenance id="module" />;

         case "invoices":
        return <InvoiceMaintenance id="module" />;


        case "CustomerAgeing":
        return <AllCustomerOnlineAgingInquiry id="module" />;
		
		case "CustomerBalanceInquiry":
        return <CustomerBalanceInquiry id="module" />;		


     case "salesPersonOrder":
        return <SalesPersonOrder id="module" />;
		
	case "ats":
        return <ATSInquiry id="module" />;		
		
		
      default:
        return null;
    }
  };
  return (
    <Layout logoutHandler={logoutHandler}>
      <div className="content theme_dark">{renderModule()}</div>
    </Layout>
  );
};

export default Home;
